import { Injectable } from '@angular/core';
import { MaintenanceControllerStatus200Response } from '@api-swagger-client/index';
import { Observable, tap, catchError, throwError } from 'rxjs';
import { MaintenanceControllerService } from '../../../projects/api-swagger-client/src/api/maintenanceController.service';


@Injectable({
    providedIn: 'root',
})
export class MaintenanceService {
    constructor(
        private maintenanceControllerService: MaintenanceControllerService
    ) {}

   

    checkBackendStatus = (
    ): Observable<MaintenanceControllerStatus200Response> => {
        return this.maintenanceControllerService.maintenanceControllerStatus()
            .pipe(
                tap((response) => {
                }),
                catchError((error) => {
                    return throwError(() => error);
                })
            );
    };

}